import { Injectable } from '@angular/core';

import { LeafletTram, Tram } from "../core/tram";
import { Route } from "../core/route";
import { TramStop } from '../core/tram-stop';
import { TramPositioningService } from "../tram-positioning.service";
import { LiteEvent } from './index';

@Injectable()
export class TramCollector {
    private _subscription: any;
    private _trams: Map<number, LeafletTram>;
    get trams(): LeafletTram[] {
        let tramsInternal: LeafletTram[] = [];

        if (this._trams !== undefined)
            this._trams.forEach(t => tramsInternal.push(t));

        return tramsInternal;
    }

    private readonly _onAfterInitializeTram = new LiteEvent<LeafletTram>();
    private readonly _beforeSelectHandler = new LiteEvent<LeafletTram>();
    private readonly _afterSelectHandler = new LiteEvent<LeafletTram>();
    private readonly _nextStop = new LiteEvent<any>();

    get afterInitializeTram() { return this._onAfterInitializeTram.expose(); }
    get beforeSelect() { return this._beforeSelectHandler.expose(); }
    get afterSelect() { return this._afterSelectHandler.expose(); }
    get nextStop() { return this._nextStop.expose(); }

    constructor(private navigator: TramPositioningService) { }

    start() {
        this._trams = new Map<number, LeafletTram>();

        this.navigator.connect();
        this._subscription = this.navigator.trams.subscribe(trams => this.updateInternal(trams));
    }

    get(id: number) {
        return this._trams.get(id);
    }

    select(tramId: number): void;
    select(route: Route): void;
    select(obj) {
        if (typeof (obj) === 'number') {
            let id = obj;
            if (!this._trams.has(id))
                return;

            let tram = this._trams.get(id);
            this.selectInternal(null, tram);
        } else {
            let route = obj;
            this._trams.forEach(t => {
                if (t.routeId !== route.id)
                    return;

                t.select();
            });
        }
    }

    unselect(): void;
    unselect(tramId: number): void;
    unselect(route: Route): void;
    unselect(...objects: any[]) {
        if (objects.length === 0) {
            this.trams.forEach(t => t.unselect());
        } else if (objects.length === 1) {
            if (typeof (objects[0]) === 'number') {
                let id = objects[0];
                if (!this._trams.has(id))
                    return;

                let tram = this._trams.get(id);
                tram.unselect();
            } else {
                let route = objects[0];
                this._trams.forEach(t => {
                    if (t.routeId !== route.id)
                        return;

                    //add before and after unselect action if i need
                    t.unselect();
                });
            }
        }
    }

    enable(route: Route) {
        this._trams.forEach(t => {
            if (t.routeId !== route.id)
                return;

            t.enable();
        });
    }

    disable(route: Route) {
        this._trams.forEach(t => {
            if (t.routeId !== route.id)
                return;

            t.disable();
        });
    }

    finish() {
        if (this._subscription)
            this._subscription.unsubscribe();
        // this.navigator.close();
    }

    private updateInternal(trams: Tram[]) {
        trams.forEach(t => {
            if (!this._trams.has(t.id)) {
                this.initTram(t);
                return;
            }

            this.updateTram(t);
        });
    }

    private convertInternal(tram: Tram): LeafletTram {
        let lTram = new LeafletTram(tram);
        lTram.marker.on('click', e => this.selectInternal(e, lTram));

        return lTram;
    }

    private selectInternal(e: any, tram: LeafletTram) {
        if (this._beforeSelectHandler)
            this._beforeSelectHandler.trigger(tram);

        // unselect all selected tram before
        this._trams.forEach(t => {
            if (!t.isSelected)
                return;

            t.unselect();
        });

        tram.select();

        if (this._afterSelectHandler)
            this._afterSelectHandler.trigger(tram);
    }

    private initTram(tram: Tram) {
        let lTram = this.convertInternal(tram);
        this._trams.set(lTram.id, lTram);

        if (this._onAfterInitializeTram)
            this._onAfterInitializeTram.trigger(lTram);
    }
    private updateTram(tram: Tram) {
        let _tram = this._trams.get(tram.id) as LeafletTram;
        if (_tram === null) {
            return;
        }
        if (!_tram.isEnabled) {
            return;
        }

        _tram.updatePosition(tram.position.coordinate);
        _tram.isReverseTrip = tram.isReverseTrip;
        _tram.state = tram.state;
        _tram.publicNumber = tram.publicNumber;
        _tram.scheduleId = tram.scheduleId;

        // if (!_tram.nextStop)
        //     return;

        _tram.nextStop = tram.nextStop;

        // if (!_tram.nextStop)
        //     return;
        // if (_tram.currentStopId !== _tram.nextStop.stopId) {
        //     _tram.currentStopId = _tram.nextStop.stopId;

        if (!_tram.isSelected)
            return;

        if (this._nextStop)
            this._nextStop.trigger({ tramId: _tram.id, nextStop: _tram.nextStop });
        // }
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/tram-collector.ts